export function isSourceConnected(source: { status?: string }): boolean {
  return (source.status ?? '').toLowerCase() === 'ready';
}
